import { combineReducers, type Reducer, type ReducersMapObject } from 'redux';

import { MODULE_NAME } from '../../constants';

import { reducer as articleCollectionsReducer, type State as ArticleCollectionsState } from './article.collections';
import { reducer as issuePageSetReducer, type State as IssuePageSetState } from './issue.pageset';
import { reducer as userCollectionsReducer, type State as UserCollectionsState } from './user.collections';

interface IState {
    userCollections: UserCollectionsState;
    issuePageSet: IssuePageSetState;
    articleCollections: ArticleCollectionsState;
}

const reducers: ReducersMapObject<IState> = {
    userCollections: userCollectionsReducer,
    issuePageSet: issuePageSetReducer,
    articleCollections: articleCollectionsReducer,
};

const reducer: Reducer<IState> = combineReducers(reducers);

const getModuleState = (state: { [MODULE_NAME]: IState }) => state[MODULE_NAME];

export { getModuleState, IState, reducer };
